'use client';

import 'aos/dist/aos.css';
import { useAOSReplacement } from './useAOSReplacement';

export const AOSInclude = () => {
	useAOSReplacement();
	return null;
};
